import { styled, Box } from "@mui/material";
import Pattern1 from "./children/Patterns/p1";
import Pattern2 from "./children/Patterns/p2";
import Pattern3 from "./children/Patterns/p3";
import Pattern4 from "./children/Patterns/p4";
import Pattern5 from "./children/Patterns/p5";
import Pattern6 from "./children/Patterns/p6";
import Pattern7 from "./children/Patterns/p7";
import Pattern8 from "./children/Patterns/p8";
import Pattern9 from "./children/Patterns/p9";
import Pattern11 from "./children/Patterns/p11";
import Pattern10 from "./children/Patterns/p10";
import Pattern12 from "./children/Patterns/p12";
import Pattern13 from "./children/Patterns/p13";
import Pattern14 from "./children/Patterns/p14";
import Pattern15 from "./children/Patterns/p15";
import Pattern16 from "./children/Patterns/p16";
import Pattern17 from "./children/Patterns/p17";
import Pattern18 from "./children/Patterns/p18";
import Pattern19 from "./children/Patterns/p19";
import Pattern20 from "./children/Patterns/p20";
import Pattern21 from "./children/Patterns/p21";
import Pattern22 from "./children/Patterns/p22";
import Pattern23 from "./children/Patterns/p23";
import Pattern24 from "./children/Patterns/p24";
import Pattern25 from "./children/Patterns/p25";
import Pattern26 from "./children/Patterns/p26";
import Pattern27 from "./children/Patterns/p27";
import Pattern28 from "./children/Patterns/p28";

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  margin-top: -5px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f7f2fa;
`;

export const CornerHeading = styled("p")`
  font-size: 16px;
  color: #000000;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  margin-right: 10px;
  margin-top: 8px;
`;

export const RowDiv = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OverlayContainer = styled("div")`
  position: relative;
  width: 100%;
  height: 20vh;
  margin-top: 20px;
  background-color: ${(props) => props.bgColor || "rgba(67, 255, 100, 0.5)"};
  overflow: hidden;
`;

export const PatternImage = styled("img")`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Overlay = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.bgColor || "rgba(67, 255, 100, 0.5)"};
  pointer-events: none;
`;

export const PatternGridContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
`;

export const GridContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
  margin-bottom: 20px;
  margin-top: 10px;
`;

export const PatternItemImage = styled("img")`
  height: 40px;
  width: 40px;
  object-fit: cover;
  margin: 2px;
  cursor: pointer;
`;

export const SwatchOverlayImage = styled("div")`
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    background-color: ${(props) => props.overlayColor || "rgba(0, 0, 0, 0.5)"};
    opacity: ${(props) => (props.isPattern ? 1 : 0)};
    pointer-events: none;
  }
`;

export const SwatchBackgroundImage = styled("img")`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

export const StyledRightIconContainer = styled("div")`
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  overflow: hidden;
  background: ${(props) => props.bgColor || "transparent"};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledColorTypeSelector = styled("div")`
  cursor: pointer;
  width: 55px;
  height: 55px;
  border-radius: 30px;
  margin: 2.5px;
  border: ${(props) =>
    props.isSelected ? "2px solid #a8acb3" : "0.2px solid #e1e4e8"};
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    overflow: hidden;
    background-color: ${(props) => props.wallpaperOverlayColor};
  }
`;

export const StyledEmptyPattern = styled("div")`
  height: 40px;
  width: 40px;
  margin: 2px;
  cursor: pointer;
  border-radius: 4px;
  border: ${(props) => (props.isSelected ? "1px solid gray" : "none")};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f7f9;
`;

export const StyledPatternContainer = styled("div")`
  height: 40px;
  width: 40px;
  overflow: hidden;
  margin: 2px;
  cursor: pointer;
  border-radius: 4px;
  border: ${(props) => (props.isSelected ? "1px solid gray" : "none")};
  background-color: #f6f7f9;
`;

export const patterns = [
  { id: 0, component: "Empty" },
  { id: 1, component: Pattern1 },
  { id: 2, component: Pattern2 },
  { id: 3, component: Pattern3 },
  { id: 4, component: Pattern4 },
  { id: 5, component: Pattern5 },
  { id: 6, component: Pattern6 },
  { id: 7, component: Pattern7 },
  { id: 8, component: Pattern8 },
  { id: 9, component: Pattern9 },
  { id: 10, component: Pattern10 },
  { id: 11, component: Pattern11 },
  { id: 12, component: Pattern12 },
  { id: 13, component: Pattern13 },
  { id: 14, component: Pattern14 },
  { id: 15, component: Pattern15 },
  { id: 16, component: Pattern16 },
  { id: 17, component: Pattern17 },
  { id: 18, component: Pattern18 },
  { id: 19, component: Pattern19 },
  { id: 20, component: Pattern20 },
  { id: 21, component: Pattern21 },
  { id: 22, component: Pattern22 },
  { id: 23, component: Pattern23 },
  { id: 24, component: Pattern24 },
  { id: 25, component: Pattern25 },
  { id: 26, component: Pattern26 },
  { id: 27, component: Pattern27 },
  { id: 28, component: Pattern28 },
];
